var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-chart',{ref:"chart",staticStyle:{"height":"37vh!important"},attrs:{"options":_vm.chartOptions,"theme":"ovilia-green"},on:{"datazoom":_vm.dataZoom}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }